import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { DeviceDefaultIcon } from "@jti/brand-icons/device-default";
import { DevicePhoneIcon } from "@jti/brand-icons/device-phone";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { MailClassicIcon } from "@jti/brand-icons/mail-classic";
import { ProfileDefaultIcon } from "@jti/brand-icons/profile-default";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { LinkBehaviour } from "../../../../components/LinkBehaviour";
import styles from "./ContactInfoBlock.module.scss";
const CONTACT_TYPE_ICONS = {
    Phone: DevicePhoneIcon,
    Account: ProfileDefaultIcon,
    Mail: MailClassicIcon,
    Product: DeviceDefaultIcon,
};
export const ContactInfoBlock = ({ info, additionalInfo, ctaLink, contactType }) => {
    const handleClick = () => {
        if (contactType === "Phone") {
            dispatchTrackingEvent(TrackingEvents.TrackingContactUsPhoneClick);
        }
        else {
            dispatchTrackingEvent(TrackingEvents.TrackingContactUsClick);
        }
    };
    const IconComponent = CONTACT_TYPE_ICONS[contactType];
    return (_jsxs(LinkBehaviour, { className: styles.link, href: ctaLink, onClick: handleClick, "data-testid": "contact-us-details-info-block", rel: "noreferrer", children: [_jsx(IconComponent, { className: styles.infoBlockIcon }), _jsxs("div", { className: styles.infoSection, children: [info && (_jsx("div", { className: classNames(styles.infoBlockSubInfo, { [styles.infoBlockSubInfoPhone]: contactType === "Phone" }), children: info })), additionalInfo && _jsx("div", { className: styles.infoBlockSubAdditionalInfo, children: additionalInfo })] }), _jsx(LongArrowForwardIcon, { className: styles.infoBlockCtaIcon })] }));
};
//# sourceMappingURL=ContactInfoBlock.js.map